import axiosInstance from './BaseService';
import  PagePermissionData  from '../models/PagePermissionData';


//Get Page Permission By Role Code
async function getPagePermissionByUserName(UserName: string, pageCode: string): Promise<PagePermissionData[]> {
  try {
    const response = await axiosInstance.get<PagePermissionData[]>(`/pagepermissions/${UserName}/${pageCode}`);
    return response.data;
  }
  catch (error) {
    throw error;
  }  
}
async function menuPermissionByUserName(UserName: string) {
    try{
        const response = await axiosInstance.get<PagePermissionData[]>(`/menupermissions/${UserName}`);
        return response.data;
    }catch(error){
        throw error;
    }
}
export {getPagePermissionByUserName, menuPermissionByUserName};
